module.exports = __webpack_public_path__ + "static/media/เถาะ.2cf16d81.png";